/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext } from 'react';
import OwlCarousel from 'react-owl-carousel';
import { LandingPageData } from '../../contexts/LandingPageContext';
import API_URL from '../../services';
import noData from '../../assets/images/noData.gif';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

export default function TopProducts() {
  const brandStyle = {
    width: '50%',
  };

  const options = {
    margin: 10,
    responsiveClass: true,
    dots: false,
    autoplay: true,
    lazyLoad: true,
    smartSpeed: 500,
    responsive: {
      0: {
        items: 2,
      },
      400: {
        items: 2,
      },
      600: {
        items: 3,
      },
      700: {
        items: 4,
      },
      1000: {
        items: 5,
      },
      1700: {
        items: 6,
      },
    },
  };

  const { data: { recent } } = useContext(LandingPageData);
  const isDataThere = recent.length ? true : false; //eslint-disable-line
  return (
    <>
      {isDataThere && (
        <OwlCarousel className="owl-theme border-5 xl:px-10" loop {...options}>
          {recent.length && recent.map((value) => (
            <div
              className="item group flex flex-col border-2
                    rounded-2xl bg-white
                    hover:shadow-xl"
              key={`${value.name}${value.id}`}
            >
              <div className="flex justify-center">
                <img
                  src={`${API_URL}${value.img}`}
                  alt={value.name}
                  className="object-contain rounded-t-lg w-full
                          transition delay-150 ease-in-out
                          hover:scale-90 z-0
                          xs:h-1/3
                          md:h-[229px]
                          xl:h-[200px]"
                  loading="lazy"
                />
              </div>
              <div className="flex flex-col gap-2 mb-2">
                <div className="flex justify-start pl-1 gap-2">
                  <img
                    src={`${API_URL}/${value.brand_img}`}
                    style={brandStyle}
                    className="w-1/2 h-[40px] object-contain
                            xs:h-[20px] xs:w-1/2
                            sm:h-[20px] sm:w-1/2
                            md:w-1/2"
                    loading="lazy"
                    alt={value.brand}
                  />
                </div>
                <div className="flex flex-col gap-0">
                  <p className="pl-2 font-serif text-gray-500 group-hover:text-main group-hover:font-bold capitalize">{value.name}</p>
                  <p className="pl-2 font-serif text-sm text-gray-500 group-hover:hidden capitalize">{value.brand}</p>
                  <button
                    type="button"
                    className="outline-2 w-1/3 mx-2 bg-darkbg text-sm text-gray-700
                          rounded-lg hidden group-hover:block"
                  >
                    Compare
                  </button>
                </div>
                <button
                  type="button"
                  className={`outline-2 mx-2
                        ${value.in_stock ? 'bg-darkbg text-blackytext' : 'bg-primary text-main'}
                        rounded-lg w-3/4 md:w-1/2 self-end py-1 text-sm`}
                >
                  {value.in_stock ? 'Available in stock' : 'Available in order'}
                </button>
              </div>
            </div>
          ))}
        </OwlCarousel>
      )}
      {!isDataThere && (
        <div className="flex justify-center items-center">
          <img src={noData} loading="lazy" alt="no data available" className="object-fit h-1/3 w-1/3" />
        </div>
      )}
    </>
  );
}
